import { generateOrganizationSchema, generateWebSiteSchema } from './organization';

/**
 * Generate Article schema for editorial guide pages
 * @param {Object} params - Schema generation parameters
 * @param {string} params.headline - Article headline/title
 * @param {string} params.description - Article description
 * @param {string} params.url - Full URL of the article
 * @param {string} params.slug - URL slug for the article
 * @param {string} params.imageUrl - Featured image URL (should be 1200×630+)
 * @param {string} params.imageAlt - Image alt text
 * @param {string} params.datePublished - ISO date when article was published
 * @param {string} params.dateModified - ISO date when article was last modified
 * @param {Array} params.breadcrumbItems - Array of breadcrumb items with name and url
 * @returns {Object} JSON-LD schema object
 */
export default function generateArticleSchema({
  headline,
  description,
  url,
  slug,
  imageUrl,
  imageAlt = '',
  datePublished,
  dateModified,
  breadcrumbItems = [],
}) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      generateOrganizationSchema(),
      generateWebSiteSchema(),
      {
        '@type': 'Article',
        '@id': `${url}#article`,
        headline,
        description,
        image: {
          '@type': 'ImageObject',
          url: imageUrl,
          width: 1200,
          height: 630,
        },
        datePublished,
        dateModified: dateModified || datePublished,
        author: {
          '@type': 'Organization',
          '@id': 'https://www.realestateagents.com/#organization',
          name: 'RealEstateAgents.com',
        },
        publisher: {
          '@type': 'Organization',
          '@id': 'https://www.realestateagents.com/#organization',
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': `${url}#webpage`,
        },
        inLanguage: 'en-US',
      },
      {
        '@type': 'WebPage',
        '@id': `${url}#webpage`,
        url,
        name: headline,
        description,
        inLanguage: 'en-US',
        isPartOf: {
          '@type': 'WebSite',
          '@id': 'https://www.realestateagents.com/#website',
        },
        about: {
          '@id': `${url}#article`,
        },
        publisher: {
          '@id': 'https://www.realestateagents.com/#organization',
        },
        breadcrumb: {
          '@id': `${url}#breadcrumb`,
        },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${url}#breadcrumb`,
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: 'https://www.realestateagents.com/',
          },
          ...breadcrumbItems.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 2,
            name: item.name,
            item: item.url,
          })),
        ],
      },
    ],
  };
}
